import React from 'react'
import { RESPONSE_PENDING } from 'front-end-core/constants/responses'
import useObservable from 'front-end-core/hooks/useObservable'
import { publishedCaKeyPicks, keyPickUrl } from 'services/PublishedCaKeyPicksService'
import KeyPicks from 'components/shared/KeyPicks'
import ResponseConsumer from 'components/shared/ResponseConsumer'

const CaKeyPicks = ({ aol, isLogged, setSignUpModalIsOpen }) => {
  const keyPicks = useObservable(publishedCaKeyPicks({ aol }), RESPONSE_PENDING)
  const handleOnClick = () => !isLogged && setSignUpModalIsOpen(true)
  const cxNames = { tile: { borderColor: 'b--light-sea-green-2' } }
  const props = {
    cxNames,
    keyPicks,
    handleOnClick,
    iconName: 'icon-file-document',
    className: 'pt8 mb2',
    itemClassName: 'b--light-sea-green-2',
    getUrl: ({ articleId: id }) => keyPickUrl(id, aol),
    getItemDataAttributes: ({ title, articleId }) => ({
      'data-event-category': 'Current Awareness Key Picks',
      'data-event-action': 'Click',
      'data-event-label': `[${title}] : [${articleId}]`
    })
  }

  return (
    <ResponseConsumer
      response={keyPicks}
      pendingComponent={() => <KeyPicks {...props} pending />}
      content={() => <KeyPicks {...props} />}
    />
  )
}

export default CaKeyPicks
